// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"0be11675","472":"18a72698","643":"0e02bb73","734":"a484f421","987":"446c62e4"}[chunkId] + ".chunk.js";
};